module.exports = __webpack_public_path__ + "img/logo_mfg.8ad90161.png";